import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { getDoc, doc, collection, DocumentSnapshot } from "firebase/firestore"
import { db } from "../firebase";

export const BreadcrumbsHunter = () => {
  const { hunterId } = useParams()
  const [hunterName, setHunterName] = useState<string>('')
  const huntersRef = collection(db, "hunters")

  useEffect(() => {
    getDoc(doc(huntersRef, hunterId)).then((doc: DocumentSnapshot) => {
      doc.exists() && setHunterName(doc.data().name)
    })
  })

  return <>{hunterName ? hunterName : "-"}</>;
};
